import { getEnvironmentStage, isDevEnvironmentStage } from './environmentUtils';
import localStorageHelper from './localStorageHelper';

// Re-export the utility functions for backward compatibility
export { getEnvironmentStage } from './environmentUtils';

const checkEnvironmentStage = (environment) => {
    let env = environment;
    if (!env) {
        const envProps = localStorageHelper.nonEncrypted.getItem('environmentProperties');
        env = envProps && envProps.environment;
    }
    return getEnvironmentStage(env);
};

export const isDev = (environment) => {
    const environmentStage = checkEnvironmentStage(environment);
    return isDevEnvironmentStage(environmentStage);
};
